import { paths as sharedPaths } from "@blueskydataplatform/shared-ui/config/paths";

export const paths = {
  ...sharedPaths,
  base: "/auth",
  home: {
    path: "/",
    getHref: () => "/",
  },
  register: {
    path: "/register/:inviteCode?",
    getHref: (inviteCode?: string) => `/register${inviteCode ? `/${inviteCode}` : ""}`,
  },
  finishRegistration: {
    path: "/finish-registration",
    getHref: () => "/finish-registration",
  },
  subscriptionRequired: {
    path: "/subscription-required",
    getHref: () => "/subscription-required",
  },
  regionUnavailable: {
    path: "/region-unavailable",
    getHref: (params?: { country?: string }) => {
      const base = "/region-unavailable";
      if (!params?.country) return base;
      return `${base}?country=${encodeURIComponent(params.country)}`;
    },
  },
  passwordReset: {
    path: "/password-reset",
    getHref: () => "/password-reset",
  },
  code: {
    path: "/code/:code",
    getHref: (code: string) => `/code/${code}`,
  },
} as const;

export const apiPaths = {
  providers: {
    getProviders: {
      path: "/providers-metadata",
      getPath: () => "/providers-metadata",
    },
    getProvider: {
      path: "/providers-metadata/:providerId",
      getPath: (providerId: string) => `/providers-metadata/${providerId}`,
    },
  },
  subscriptions: {
    checkDatasetsSubscription: {
      path: "/check-datasets-subscription",
      getPath: () => "/check-datasets-subscription",
    },
  },
  account: {
    getAccountInfo: { path: "/account/info", getPath: () => "/account/info" },
  },
  auth: {
    login: {
      path: "/login",
      getPath: () => "/login",
    },
    signUp: {
      path: "/create-account",
      getPath: () => "/create-account",
    },
    resetPasswordPetition: {
      path: "/reset-password",
      getPath: () => "/reset-password",
    },
    resetPasswordChange: {
      path: "/change-password",
      getPath: () => "/change-password",
    },
    verify2FA: {
      path: "/verify-code",
      getPath: () => "/verify-code",
    },
    send2FA: {
      path: "/send-code",
      getPath: () => "/send-code",
    },
    checkEmailVerification: {
      path: "/check-email-verification",
      getPath: () => "/check-email-verification",
    },
    getSoftwareStatement: {
      path: "/software-statement",
      getPath: () => "/software-statement",
    },
    getMcpClient: {
      path: "/mcp-client",
      getPath: () => "/mcp-client",
    },
  },
  datasets: {
    getDataset: {
      path: "/datasets/:id",
      getPath: (id: string) => `/datasets/${id}`,
    },
  },
};
